import React, { useState } from 'react';
import {
  TabContent, TabPane, Nav, NavItem, NavLink, Jumbotron, Button,
} from 'reactstrap';
import { useQuery, useMutation } from '@apollo/react-hooks';
import classnames from 'classnames';
import TemplatesValidationPage from './templates-validation';
import TemplatesOrderCategoriesPage from './template-order-categories';
import { GET_TEMPLATES, GET_TEMPLATE_CATEGORIES } from '../../query/query';
import { UPDATE_RANDOM_TEMPLATE } from '../../mutation/mutation';

const TABS = Object.freeze({
  VALIDATE_TEMPLATES: 0,
  ORDER_CATEGORIES: 1,
  RANDOMIZATION: 2,
});

const TemplatesManagerHome = () => {
  const [activeTab, setActiveTab] = useState(TABS.VALIDATE_TEMPLATES);

  const {
    data: { savGetTemplates = [] } = {},
    loading: savGetTemplatesLoading,
    refetch: refetchSavGetTemplates,
  } = useQuery(
    GET_TEMPLATES, { fetchPolicy: 'cache-first' },
  );

  const {
    data: { savGetTemplateCategories: templateCategories = [] } = {},
  } = useQuery(
    GET_TEMPLATE_CATEGORIES, { fetchPolicy: 'cache-and-network' },
  );

  const [loadingRandomize, setLoadingRandomize] = useState(false);
  const [savUpdateRandomTemplates] = useMutation(UPDATE_RANDOM_TEMPLATE);
  const onCLickRandomize = async () => {
    setLoadingRandomize(true);
    await savUpdateRandomTemplates();
    await refetchSavGetTemplates();
    setLoadingRandomize(false);
    window.location.reload();
  };

  const [refreshing, setRefreshing] = useState(false);

  return (
    <Jumbotron>
      <Nav tabs>
        <NavLink href="/templates/createbatch">Create New Batch</NavLink>
        <NavLink href="/templates/create">Create New Template</NavLink>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.VALIDATE_TEMPLATES })}
            onClick={() => setActiveTab(TABS.VALIDATE_TEMPLATES)}
          >
            Manage Templates
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.ORDER_CATEGORIES })}
            onClick={() => setActiveTab(TABS.ORDER_CATEGORIES)}
          >
            Manage Categories
          </NavLink>
        </NavItem>
        <Button
          color="success"
          type="button"
          onClick={onCLickRandomize}
          active={!loadingRandomize}
          style={{ marginLeft: 20 }}
        >
          {!loadingRandomize ? 'Randomize Templates' : 'Performing, please wait...'}
        </Button>
        {!savGetTemplatesLoading && (
          <Button
            color="primary"
            type="button"
            onClick={async () => {
              setRefreshing(true);
              await refetchSavGetTemplates();
              setRefreshing(false);
            }}
            active={!savGetTemplatesLoading && !refreshing}
            style={{ marginLeft: 20 }}
          >
            {refreshing ? 'Refreshing...' : 'Refresh templates'}
          </Button>
        )}
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane tabId={TABS.VALIDATE_TEMPLATES}>
          <TemplatesValidationPage
            savGetTemplates={savGetTemplates}
            savGetTemplatesLoading={savGetTemplatesLoading}
            templateCategories={templateCategories}
            refetchSavGetTemplates={refetchSavGetTemplates}
          />
        </TabPane>
        <TabPane tabId={TABS.ORDER_CATEGORIES}>
          <TemplatesOrderCategoriesPage />
        </TabPane>
      </TabContent>
    </Jumbotron>
  );
};

export default TemplatesManagerHome;



// WEBPACK FOOTER //
// ./src/components/templates-manager/templates-manager.js